import '../../styles.global.css';
import '../../assets/styles/Autocomplete.module.css';

var styles = {"wrapper":"wru__Autocomplete__wrapper","autocomplete":"wru__Autocomplete__autocomplete","show":"wru__Autocomplete__show","showHistory":"wru__Autocomplete__showHistory","item":"wru__Autocomplete__item","selected":"wru__Autocomplete__selected","overlay":"wru__Autocomplete__overlay","enter":"wru__Autocomplete__enter","clear":"wru__Autocomplete__clear","message":"wru__Autocomplete__message","fade":"wru__Autocomplete__fade"};

export { styles as default };
//# sourceMappingURL=Autocomplete.module.scss.js.map
